<div class="container-fluid">
    <div class="page-header">
      <div class="row">
        <div class="col-lg-6">
          <div class="page-header-left">
            <h3>Questions RH</h3>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Table to display QuestionsRH entries -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h5>Questions RH List</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Categories</th>
                    <th>Sous Categories</th>
                    <th>Titre</th>
                    <th>Descriptions</th>
                    <th>Pieces Joint</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let question of filteredQuestionsList">
                    <td>{{ question.categories }}</td>
                    <td>{{ question.sousCategories }}</td>
                    <td>{{ question.titre }}</td>
                    <td>{{ question.descriptions }}</td>
                    <td>
                      <button *ngIf="question.piecesJoint" class="btn btn-primary me-2" (click)="fetchPdf(question.piecesJoint)">
                        View PDF
                      </button>
                    </td>
                    <td>{{ question.username }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Modal -->
  <div #pdfModal class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 800px;" role="document">
      <div class="modal-content bg-transparent">
        <div class="modal-header">
          <h5 class="modal-title">PDF Viewer</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <iframe width="100%" height="600" frameborder="0"></iframe>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  